import React from 'react';
import { PageBanner } from '../components/PageBanner';
import { AboutSection } from '../components/AboutSection';
import { BookingCTA } from '../components/BookingCTA';
export function AboutPage() {
  return <>
      <PageBanner title="About Us" subtitle="Honoring tradition while elevating modern style." backgroundImage="https://cdn.magicpatterns.com/uploads/9HJ51oQBNvS7NQJc6RsA29/istockphoto-1370569973-2048x2048.jpg" data-id="element-285" />
      <AboutSection data-id="element-286" />
      <BookingCTA data-id="element-287" />
    </>;
}